import React, { FC } from 'react'
import styled from 'styled-components'

import { Button } from '@ucheba/ui/components/Button/desktop'

import { Dialog } from '@ucheba/ui/components/Dialog/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'

import robotImage from '../../../images/robotImage.png'
import { IEducationalInstitutionAddedNotificationProps } from '../types'

const Content = styled.div`
  display: flex;
  column-gap: 16px;
`

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  a {
    width: 281px;
  }
`

const Image = styled.img`
  width: 239px;
  height: 280px;
  flex-shrink: 0;
  margin: 0 -32px -32px 0;
`

const ButtonStyled = styled(Button)`
  span {
    flex-shrink: 0;
  }
`

const EducationalInstitutionAddedNotification: FC<
  IEducationalInstitutionAddedNotificationProps
> = (props) => {
  const { open = false, title, onClose, lsKey } = props

  const handleOnClose = (): void => {
    localStorage.setItem(lsKey, 'true')
    onClose()
  }

  if (!open) return null

  return (
    <Dialog spacing='xlarge' open={open} overflow='auto' onClose={handleOnClose}>
      <Heading html h2={title} spacing='xxsmall' />
      <Content>
        <LeftSide>
          <Text lineHeight='h5' fontSize='h5'>
            Составить план проще всего в планировщике поступления — бесплатном сервисе,
            который поможет быстро подобрать подходящие учебные заведения и программы по
            интересам и предметам ЕГЭ.
          </Text>

          <Button href='/for-abiturients/planner/about' target='_blank' color='blue'>
            Подробнее о планировщике
          </Button>

          <ButtonStyled
            href='/for-abiturients/planner/plan'
            target='_blank'
            color='blue'
            view='outline'
          >
            Посмотреть план поступления
          </ButtonStyled>
        </LeftSide>

        <Image src={robotImage} alt='картинка робота' />
      </Content>
    </Dialog>
  )
}

export default EducationalInstitutionAddedNotification
